import type { ComponentProps } from 'react';
import React from 'react';
import styled from '@emotion/styled';
import { ThirdPartyProvider } from 'graphql-ts-types';
import { width } from 'styled-system';

import appleSvg from 'common/assets/images/apple.svg';
import googleSvg from 'common/assets/images/google.svg';
import { Flex } from 'common/components/Flex';
import type { CommonTypographyProps } from 'common/components/Typography';
import { HeadlineH8 } from 'common/components/Typography';
import { ThirdPartyProviderString } from 'common/enums/ThirdPartyProvider';
import { useLocalization } from 'common/providers/LocaleProvider';

const ICON_SIZE = '24px';

const UnstyledContainer = styled(Flex)``;

const Container = (props: ComponentProps<typeof UnstyledContainer>) => (
  <UnstyledContainer alignItems="center" pt="sp_4" mb="sp_16" {...props} />
);

const headingTextStyles: CommonTypographyProps = {
  color: 'sys.neutral.text.default',
  m: 'sp_0',
  ml: 'sp_8',
  as: 'h4',
};

const UnstyledImage = styled.img`
  ${width};
`;

const Image = (props: ComponentProps<typeof UnstyledImage>) => (
  <UnstyledImage width={ICON_SIZE} {...props} />
);

const ICONS = {
  [ThirdPartyProvider.Google]: googleSvg,
  [ThirdPartyProvider.Apple]: appleSvg,
};

const ThirdPartyDataHeading = ({ provider }: { provider: ThirdPartyProvider }) => {
  const { r } = useLocalization();

  return (
    <Container>
      <Image src={ICONS[provider]} alt="" />
      <HeadlineH8 {...headingTextStyles}>
        {r.t('h24_register_data_provided_by', {
          provider: ThirdPartyProviderString[provider],
        })}
      </HeadlineH8>
    </Container>
  );
};

export default ThirdPartyDataHeading;
